// import logo from '../../assets/img/logo.png';
import { CloseIcon, Icon, ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { createRef, useState, useEffect } from 'react';
import { useStateContext } from '../../context/ContextProvider';
import { GrAdd } from 'react-icons/gr';
import property from '../../assets/images/property1.jpg'
import countryData from '../../assets/dataJson/countries.json';
import Resizer from "react-image-file-resizer";


import {
    Box,
    Select,
    FormControl,
    FormLabel,
    Input,
    Flex,
    InputGroup,
    HStack,
    InputRightElement,
    useColorModeValue,
    Stack,
    useToast,
    Button,
    Heading,
    Text,
    Image,
    Alert,
    AlertIcon,
    Spinner,
    InputLeftElement,
    Textarea,
    Avatar,
    AvatarBadge,
    Grid,
    GridItem,
    Checkbox,

} from '@chakra-ui/react';
import axiosClient from '../../axios-client';
import { TfiReload } from 'react-icons/tfi';
import MySelect from "react-select";
import { FaPencilAlt } from 'react-icons/fa';
import { AiOutlinePlus } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import { FiEdit3 } from 'react-icons/fi';
import { renameFile } from '../../services/renameFile';

const linkStyle = {
    color: '#3C8DBC',
    textDecoration: "underline"
}


export default function EditService() {
    //toast variable
    const inputColor = useColorModeValue("gray.300", "gray.600")
    const [selectedCountry, setSelectedCountry] = useState({});
    const toast = useToast()
    const navigate = useNavigate()
    const [data, setData] = useState([]);
    const [listData, setListData] = useState([]);

    const { user, isLoading, setIsLoading } = useStateContext()

    const [message, setMessage] = useState('')

    const [title, setTitle] = useState('')
    const [description, setDescription] = useState('')
    const [price, setPrice] = useState('')
    const [selectedCategory, setSelectedCategory] = useState('')
    const [selectedCurrency, setSelectedCurrency] = useState('')
    const [isChecked, setIsChecked] = useState(false);

    const [selectedType, setSelectedType] = useState('')
    const [selectedImage, setSelectedImage] = useState()
    const [image, setImage] = useState()
    const { t } = useTranslation();

    // const handleChangeImage = (e) => {
    //     const image = e.target.files[0]
    //     setSelectedImage(image)
    // }
    const location = useLocation()


    useEffect(() => {
        axiosClient.get(`/services/${location.state.idService}/`)
            .then((res) => {
                setData(res.data)
            })
            .catch((error) => {
                // console.error(error);
            });

        axiosClient.get(`/services/`)
            .then((res) => {
                setListData(res.data)
            })
            .catch((error) => {
                // console.error(error);
            });

        // if (selectedImage) {
        //     setImage(URL.createObjectURL(selectedImage))
        // }
        // else {
        //     setSelectedImage()
        // }

    }, [])

    const [imageListe, setimageListe] = useState([]);
    const [selectedImageList, setSelectedImageList] = useState([]);
    const [isLoadingImages, setIsLoadingImages] = useState(true)

    useEffect(() => {

        axiosClient.get(`/services/${location.state.idService}/`)
            .then((res) => {
                setListData(res.data)
                setIsChecked(res.data.isActive);

                const list = [];
                const services = res.data.images
                for (let index = 0; index < services?.length; index++) {
                    list.push(services[index].image);
                    setSelectedImageList(list);
                    setimageListe(list);
                }
                setIsLoadingImages(false)

            })
            .catch((error) => {
                // console.error(error);
            });


    }, [])
    // const handleChangeImage = (e) => {
    //     const image = e.target.files;
    //     const extensions = ['.png', '.jpg', '.jpeg', '.webp']
    //     if (image) {
    //         if (image[0]?.name.length > 60) {

    //             toast({
    //                 description: "Nom de l'image dépasse 60 caractères! Veuillez modifier le nom ! ",
    //                 status: 'warning',
    //                 variant: 'left-accent',
    //                 duration: 2000,
    //                 isClosable: true,
    //                 position: 'top-center'
    //             })
    //             e.target.value = null
    //         }
    //         else {
    //             const selectedImage = Array.from(image);
    //             if (!extensions.includes(selectedImage[0]?.name.substring(selectedImage[0]?.name.length, selectedImage[0]?.name.lastIndexOf(".")))) {
    //                 e.target.value = null
    //                 return (
    //                     toast({
    //                         title: 'Erreur d extension.',
    //                         description: "Veuillez modifier l'extension de l'image {'[*.png, *.jpg, *.jpeg, *.webp]'} !",
    //                         status: 'warning',
    //                         variant: 'left-accent',
    //                         duration: 2000,
    //                         isClosable: true,
    //                         position: 'top-center'
    //                     })


    //                 )
    //             }
    //             const ArrayImage = selectedImage.map((file) => {
    //                 return URL.createObjectURL(file);
    //             });
    //             setimageListe([...imageListe, selectedImage]);
    //             setSelectedImageList([...selectedImageList, ArrayImage]);
    //             e.target.value = null
    //         }
    //     }

    // };
    const [inputKey, setInputKey] = useState(0)
    const handleChangeImage = (e) => {
        const images = e.target.files;
        const extensions = ['.png', '.jpg', '.jpeg', '.webp'];

        if (images && images.length > 0) {
            if (selectedImageList.length + images.length > 5) {
                toast({
                    description: t("Vous ne pouvez séléctionner que 5 images au maximum !"),
                    status: 'warning',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'top-center'
                });
                setInputKey((prevKey) => prevKey + 1)
                return
            }
            const selectedImages = Array.from(images);

            selectedImages.forEach(async (image) => {
                if (image.name.length > 60) {
                    toast({
                        description: t("Nom de l'image dépasse 60 caractères! Veuillez modifier le nom ! "),
                        status: 'warning',
                        variant: 'left-accent',
                        duration: 2000,
                        isClosable: true,
                        position: 'top-center'
                    });
                } else if (!extensions.includes(image.name.substring(image.name.lastIndexOf(".")))) {
                    toast({
                        title: t("Erreur d'extension."),
                        description: t("Veuillez modifier l'extension de l'image {'[*.png, *.jpg, *.jpeg, *.webp]'} !"),
                        status: 'warning',
                        variant: 'left-accent',
                        duration: 2000,
                        isClosable: true,
                        position: 'top-center'
                    });
                } else {
                    const uri = await new Promise((resolve, reject) => {
                        Resizer.imageFileResizer(
                            image,
                            451,
                            800,
                            'png',
                            100,
                            0,
                            (uri) => {
                                resolve(uri);
                            },
                            'file'
                        );
                    });
                    const imageURL = URL.createObjectURL(uri);
                    setimageListe((prevImageList) => [...prevImageList, image]);
                    setSelectedImageList((prevSelectedImages) => [...prevSelectedImages, imageURL]);
                }
            });

            // Reset the input value after processing all selected images
            setInputKey((prevKey) => prevKey + 1)
        }
    };

    // const isEmpty = () => {
    //     return !last_name || !first_name || !email || !pwd || !selectedSexe || !selectedCountry.label
    // };

    // const onSubmit = () => {

    //     const formData = new FormData()
    //     if (title) formData.append("title", title)
    //     if (description) formData.append("description", description)
    //     if (price) formData.append("price", price)
    //     if (selectedCategory) formData.append("category", selectedCategory)

    //     try {
    //         axiosClient.patch(`/services/${location.state.idService}/`, formData).then((res) => {
    //             console.log('res data patch, ', res.data);
    //             // dispatch(setAjoutArticle(res.data))
    //         });
    //     }
    //     catch (error) {
    //         console.error('Error fetching boosting value:', error);
    //     }

    //     axiosClient
    //         .get(`/service-images/?search=${location.state.idService}`)
    //         .then((res) => {
    //             const deleteImages_List = res.data.filter(
    //                 (e) => !imageListe.includes(e.image)
    //             );
    //             console.log("data image : ", deleteImages_List);
    //             console.log("image list : ", imageListe);
    //             for (let index = 0; index < deleteImages_List.length; index++) {
    //                 axiosClient.delete(`/service-images/${deleteImages_List[index].id}/`);
    //             }
    //             const newImagesToAdd = []
    //             for (let index = 0; index < imageListe.length; index++) {
    //                 if (typeof imageListe[index] !== "string") {
    //                     console.log("image inside function : ", imageListe[index]);
    //                     newImagesToAdd.push(imageListe[index])
    //                 }
    //             }
    //             console.log('newImagesToAdd : ', newImagesToAdd);

    //             const chList = []
    //             var lienImages = []
    //             for (let index = 0; index < newImagesToAdd.length; index++) {
    //                 const formData = new FormData()
    //                 formData.append("service", location.state.idService);
    //                 formData.append("image", newImagesToAdd[index][0]);
    //                 axiosClient.post(`/service-images/`, formData)
    //                     .then(() => {

    //                     })

    //             }

    //             console.log('Lien imaggggggggggges : ', lienImages);

    //             const dataService = []
    //             dataService.push(imageListe)
    //             var dataaaaaaaa
    //             const imageData = lienImages
    //             // imageData.push(lienImages)
    //             console.log('dataaaaaaaaaa image dyal alio : ', dataService);
    //             axiosClient.get(`/services/${location.state.idService}/`).then((res) => {
    //                 const { images, ...myNewData } = res.data
    //                 let check = false
    //                 const getDataImage = []

    //                 axiosClient.get(`/service-images/?search=${location.state.idService}`).then(response => {
    //                     getDataImage.push(response.data)
    //                     check = true
    //                     if (check) {
    //                         dataaaaaaaa = {
    //                             ...myNewData,
    //                             images: getDataImage[0]
    //                         }

    //                         navigate('/apa-agency-services')
    //                     }
    //                 })

    //             })




    //         });
    // };
    const onSubmit = () => {
        const formData = new FormData();

        if (title) formData.append("title", title);
        if (description) formData.append("description", description);
        if (price) formData.append("price", price);
        if (selectedCategory) formData.append("category", selectedCategory);
        if (selectedType) formData.append("type", selectedType);
        if (selectedCurrency) formData.append("currency", selectedCurrency);
        formData.append("isActive", isChecked)

        try {
            axiosClient.patch(`/services/${location.state.idService}/`, formData).then((res) => {
                // console.log('res data patch, ', res.data);
                // dispatch(setAjoutArticle(res.data))
            });
        } catch (error) {
            // console.error('Error fetching boosting value:', error);
        }

        axiosClient
            .get(`/service-images/?search=${location.state.idService}`)
            .then((res) => {
                const deleteImagesList = res.data.filter((e) => !imageListe.includes(e.image));

                // Delete images not present in the updated imageListe
                for (let index = 0; index < deleteImagesList.length; index++) {
                    axiosClient.delete(`/service-images/${deleteImagesList[index].id}/`);
                }

                // Upload new images
                const newImagesToAdd = imageListe.filter((image) => typeof image !== "string");

                const uploadPromises = newImagesToAdd.map((newImage) => {
                    const formData = new FormData();
                    formData.append("service", location.state.idService);
                    formData.append("image", renameFile(newImage));

                    return axiosClient.post(`/service-images/`, formData);
                });

                // Wait for all image uploads to complete
                Promise.all(uploadPromises)
                    .then(() => {

                        // Fetch updated service data with images
                        return axiosClient.get(`/services/${location.state.idService}/`);
                    })
                    .then((res) => {
                        const { images, ...myNewData } = res.data;
                        navigate('/apa-agency-services');
                    })
                    .catch((error) => {
                        // console.error('Error uploading new images:', error);
                    });
            })
            .catch((error) => {
                // console.error('Error fetching existing images:', error);
            });
    };


    const colorbg = useColorModeValue('white', '#2d3748')
    const txtcolor = useColorModeValue('black', 'white')
    const colorbghover = useColorModeValue('#e2e8f0', '#171923')
    const confetti = {
        light: {
            primary: '7e172c',
            secondary: 'f2c478',
        },

        dark: {
            primary: '7e172c',
            secondary: 'f2c478',
        },
    };
    const CONFETTI_LIGHT = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1500' height='745' viewBox='0 0 1600 800'%3E%3Cpath fill='%23${confetti.light.primary}' d='M1102.5 734.8c2.5-1.2 24.8-8.6 25.6-7.5.5.7-3.9 23.8-4.6 24.5C1123.3 752.1 1107.5 739.5 1102.5 734.8zM1226.3 229.1c0-.1-4.9-9.4-7-14.2-.1-.3-.3-1.1-.4-1.6-.1-.4-.3-.7-.6-.9-.3-.2-.6-.1-.8.1l-13.1 12.3c0 0 0 0 0 0-.2.2-.3.5-.4.8 0 .3 0 .7.2 1 .1.1 1.4 2.5 2.1 3.6 2.4 3.7 6.5 12.1 6.5 12.2.2.3.4.5.7.6.3 0 .5-.1.7-.3 0 0 1.8-2.5 2.7-3.6 1.5-1.6 3-3.2 4.6-4.7 1.2-1.2 1.6-1.4 2.1-1.6.5-.3 1.1-.5 2.5-1.9C1226.5 230.4 1226.6 229.6 1226.3 229.1zM33 770.3C33 770.3 33 770.3 33 770.3c0-.7-.5-1.2-1.2-1.2-.1 0-.3 0-.4.1-1.6.2-14.3.1-22.2 0-.3 0-.6.1-.9.4-.2.2-.4.5-.4.9 0 .2 0 4.9.1 5.9l.4 13.6c0 .3.2.6.4.9.2.2.5.3.8.3 0 0 .1 0 .1 0 7.3-.7 14.7-.9 22-.6.3 0 .7-.1.9-.3.2-.2.4-.6.4-.9C32.9 783.3 32.9 776.2 33 770.3z'/%3E%3Cpath fill='%23${confetti.light.secondary}' d='M171.1 383.4c1.3-2.5 14.3-22 15.6-21.6.8.3 11.5 21.2 11.5 22.1C198.1 384.2 177.9 384 171.1 383.4zM596.4 711.8c-.1-.1-6.7-8.2-9.7-12.5-.2-.3-.5-1-.7-1.5-.2-.4-.4-.7-.7-.8-.3-.1-.6 0-.8.3L574 712c0 0 0 0 0 0-.2.2-.2.5-.2.9 0 .3.2.7.4.9.1.1 1.8 2.2 2.8 3.1 3.1 3.1 8.8 10.5 8.9 10.6.2.3.5.4.8.4.3 0 .5-.2.6-.5 0 0 1.2-2.8 2-4.1 1.1-1.9 2.3-3.7 3.5-5.5.9-1.4 1.3-1.7 1.7-2 .5-.4 1-.7 2.1-2.4C596.9 713.1 596.8 712.3 596.4 711.8zM727.5 179.9C727.5 179.9 727.5 179.9 727.5 179.9c.6.2 1.3-.2 1.4-.8 0-.1 0-.2 0-.4.2-1.4 2.8-12.6 4.5-19.5.1-.3 0-.6-.2-.8-.2-.3-.5-.4-.8-.5-.2 0-4.7-1.1-5.7-1.3l-13.4-2.7c-.3-.1-.7 0-.9.2-.2.2-.4.4-.5.6 0 0 0 .1 0 .1-.8 6.5-2.2 13.1-3.9 19.4-.1.3 0 .6.2.9.2.3.5.4.8.5C714.8 176.9 721.7 178.5 727.5 179.9zM728.5 178.1c-.1-.1-.2-.2-.4-.2C728.3 177.9 728.4 178 728.5 178.1z'/%3E%3Cg fill-opacity='0.48' fill='%23FFF'%3E%3Cpath d='M699.6 472.7c-1.5 0-2.8-.8-3.5-2.3-.8-1.9 0-4.2 1.9-5 3.7-1.6 6.8-4.7 8.4-8.5 1.6-3.8 1.7-8.1.2-11.9-.3-.9-.8-1.8-1.2-2.8-.8-1.7-1.8-3.7-2.3-5.9-.9-4.1-.2-8.6 2-12.8 1.7-3.1 4.1-6.1 7.6-9.1 1.6-1.4 4-1.2 5.3.4 1.4 1.6 1.2 4-.4 5.3-2.8 2.5-4.7 4.7-5.9 7-1.4 2.6-1.9 5.3-1.3 7.6.3 1.4 1 2.8 1.7 4.3.5 1.1 1 2.2 1.5 3.3 2.1 5.6 2 12-.3 17.6-2.3 5.5-6.8 10.1-12.3 12.5C700.6 472.6 700.1 472.7 699.6 472.7zM740.4 421.4c1.5-.2 3 .5 3.8 1.9 1.1 1.8.4 4.2-1.4 5.3-3.7 2.1-6.4 5.6-7.6 9.5-1.2 4-.8 8.4 1.1 12.1.4.9 1 1.7 1.6 2.7 1 1.7 2.2 3.5 3 5.7 1.4 4 1.2 8.7-.6 13.2-1.4 3.4-3.5 6.6-6.8 10.1-1.5 1.6-3.9 1.7-5.5.2-1.6-1.4-1.7-3.9-.2-5.4 2.6-2.8 4.3-5.3 5.3-7.7 1.1-2.8 1.3-5.6.5-7.9-.5-1.3-1.3-2.7-2.2-4.1-.6-1-1.3-2.1-1.9-3.2-2.8-5.4-3.4-11.9-1.7-17.8 1.8-5.9 5.8-11 11.2-14C739.4 421.6 739.9 421.4 740.4 421.4zM261.3 590.9c5.7 6.8 9 15.7 9.4 22.4.5 7.3-2.4 16.4-10.2 20.4-3 1.5-6.7 2.2-11.2 2.2-7.9-.1-12.9-2.9-15.4-8.4-2.1-4.7-2.3-11.4 1.8-15.9 3.2-3.5 7.8-4.1 11.2-1.6 1.2.9 1.5 2.7.6 3.9-.9 1.2-2.7 1.5-3.9.6-1.8-1.3-3.6.6-3.8.8-2.4 2.6-2.1 7-.8 9.9 1.5 3.4 4.7 5 10.4 5.1 3.6 0 6.4-.5 8.6-1.6 4.7-2.4 7.7-8.6 7.2-15-.5-7.3-5.3-18.2-13-23.9-4.2-3.1-8.5-4.1-12.9-3.1-3.1.7-6.2 2.4-9.7 5-6.6 5.1-11.7 11.8-14.2 19-2.7 7.7-2.1 15.8 1.9 23.9.7 1.4.1 3.1-1.3 3.7-1.4.7-3.1.1-3.7-1.3-4.6-9.4-5.4-19.2-2.2-28.2 2.9-8.2 8.6-15.9 16.1-21.6 4.1-3.1 8-5.1 11.8-6 6-1.4 12 0 17.5 4C257.6 586.9 259.6 588.8 261.3 590.9z'/%3E%3Ccircle cx='1013.7' cy='153.9' r='7.1'/%3E%3Ccircle cx='1024.3' cy='132.1' r='7.1'/%3E%3Ccircle cx='1037.3' cy='148.9' r='7.1'/%3E%3Cpath d='M1508.7 297.2c-4.8-5.4-9.7-10.8-14.8-16.2 5.6-5.6 11.1-11.5 15.6-18.2 1.2-1.7.7-4.1-1-5.2-1.7-1.2-4.1-.7-5.2 1-4.2 6.2-9.1 11.6-14.5 16.9-4.8-5-9.7-10-14.7-14.9-1.5-1.5-3.9-1.5-5.3 0-1.5 1.5-1.5 3.9 0 5.3 4.9 4.8 9.7 9.8 14.5 14.8-1.1 1.1-2.3 2.2-3.5 3.2-4.1 3.8-8.4 7.8-12.4 12-1.4 1.5-1.4 3.8 0 5.3 0 0 0 0 0 0 1.5 1.4 3.9 1.4 5.3-.1 3.9-4 8.1-7.9 12.1-11.7 1.2-1.1 2.3-2.2 3.5-3.3 4.9 5.3 9.8 10.6 14.6 15.9.1.1.1.1.2.2 1.4 1.4 3.7 1.5 5.2.2C1510 301.2 1510.1 298.8 1508.7 297.2zM327.6 248.6l-.4-2.6c-1.5-11.1-2.2-23.2-2.3-37 0-5.5 0-11.5.2-18.5 0-.7 0-1.5 0-2.3 0-5 0-11.2 3.9-13.5 2.2-1.3 5.1-1 8.5.9 5.7 3.1 13.2 8.7 17.5 14.9 5.5 7.8 7.3 16.9 5 25.7-3.2 12.3-15 31-30 32.1L327.6 248.6zM332.1 179.2c-.2 0-.3 0-.4.1-.1.1-.7.5-1.1 2.7-.3 1.9-.3 4.2-.3 6.3 0 .8 0 1.7 0 2.4-.2 6.9-.2 12.8-.2 18.3.1 12.5.7 23.5 2 33.7 11-2.7 20.4-18.1 23-27.8 1.9-7.2.4-14.8-4.2-21.3l0 0C347 188.1 340 183 335 180.3 333.6 179.5 332.6 179.2 332.1 179.2zM516.3 60.8c-.1 0-.2 0-.4-.1-2.4-.7-4-.9-6.7-.7-.7 0-1.3-.5-1.4-1.2 0-.7.5-1.3 1.2-1.4 3.1-.2 4.9 0 7.6.8.7.2 1.1.9.9 1.6C517.3 60.4 516.8 60.8 516.3 60.8zM506.1 70.5c-.5 0-1-.3-1.2-.8-.8-2.1-1.2-4.3-1.3-6.6 0-.7.5-1.3 1.2-1.3.7 0 1.3.5 1.3 1.2.1 2 .5 3.9 1.1 5.8.2.7-.1 1.4-.8 1.6C506.4 70.5 506.2 70.5 506.1 70.5zM494.1 64.4c-.4 0-.8-.2-1-.5-.4-.6-.3-1.4.2-1.8 1.8-1.4 3.7-2.6 5.8-3.6.6-.3 1.4 0 1.7.6.3.6 0 1.4-.6 1.7-1.9.9-3.7 2-5.3 3.3C494.7 64.3 494.4 64.4 494.1 64.4zM500.5 55.3c-.5 0-.9-.3-1.2-.7-.5-1-1.2-1.9-2.4-3.4-.3-.4-.7-.9-1.1-1.4-.4-.6-.3-1.4.2-1.8.6-.4 1.4-.3 1.8.2.4.5.8 1 1.1 1.4 1.3 1.6 2.1 2.6 2.7 3.9.3.6 0 1.4-.6 1.7C500.9 55.3 500.7 55.3 500.5 55.3zM506.7 55c-.3 0-.5-.1-.8-.2-.6-.4-.7-1.2-.3-1.8 1.2-1.7 2.3-3.4 3.3-5.2.3-.6 1.1-.9 1.7-.5.6.3.9 1.1.5 1.7-1 1.9-2.2 3.8-3.5 5.6C507.4 54.8 507.1 55 506.7 55zM1029.3 382.8c-.1 0-.2 0-.4-.1-2.4-.7-4-.9-6.7-.7-.7 0-1.3-.5-1.4-1.2 0-.7.5-1.3 1.2-1.4 3.1-.2 4.9 0 7.6.8.7.2 1.1.9.9 1.6C1030.3 382.4 1029.8 382.8 1029.3 382.8zM1019.1 392.5c-.5 0-1-.3-1.2-.8-.8-2.1-1.2-4.3-1.3-6.6 0-.7.5-1.3 1.2-1.3.7 0 1.3.5 1.3 1.2.1 2 .5 3.9 1.1 5.8.2.7-.1 1.4-.8 1.6C1019.4 392.5 1019.2 392.5 1019.1 392.5zM1007.1 386.4c-.4 0-.8-.2-1-.5-.4-.6-.3-1.4.2-1.8 1.8-1.4 3.7-2.6 5.8-3.6.6-.3 1.4 0 1.7.6.3.6 0 1.4-.6 1.7-1.9.9-3.7 2-5.3 3.3C1007.7 386.3 1007.4 386.4 1007.1 386.4zM1013.5 377.3c-.5 0-.9-.3-1.2-.7-.5-1-1.2-1.9-2.4-3.4-.3-.4-.7-.9-1.1-1.4-.4-.6-.3-1.4.2-1.8.6-.4 1.4-.3 1.8.2.4.5.8 1 1.1 1.4 1.3 1.6 2.1 2.6 2.7 3.9.3.6 0 1.4-.6 1.7C1013.9 377.3 1013.7 377.3 1013.5 377.3zM1019.7 377c-.3 0-.5-.1-.8-.2-.6-.4-.7-1.2-.3-1.8 1.2-1.7 2.3-3.4 3.3-5.2.3-.6 1.1-.9 1.7-.5.6.3.9 1.1.5 1.7-1 1.9-2.2 3.8-3.5 5.6C1020.4 376.8 1020.1 377 1019.7 377zM1329.7 573.4c-1.4 0-2.9-.2-4.5-.7-8.4-2.7-16.6-12.7-18.7-20-.4-1.4-.7-2.9-.9-4.4-8.1 3.3-15.5 10.6-15.4 21 0 1.5-1.2 2.7-2.7 2.8 0 0 0 0 0 0-1.5 0-2.7-1.2-2.7-2.7-.1-6.7 2.4-12.9 7-18 3.6-4 8.4-7.1 13.7-8.8.5-6.5 3.1-12.9 7.4-17.4 7-7.4 18.2-8.9 27.3-10.1l.7-.1c1.5-.2 2.9.9 3.1 2.3.2 1.5-.9 2.9-2.3 3.1l-.7.1c-8.6 1.2-18.4 2.5-24 8.4-3 3.2-5 7.7-5.7 12.4 7.9-1 17.7 1.3 24.3 5.7 4.3 2.9 7.1 7.8 7.2 12.7.2 4.3-1.7 8.3-5.2 11.1C1335.2 572.4 1332.6 573.4 1329.7 573.4zM1311 546.7c.1 1.5.4 3 .8 4.4 1.7 5.8 8.7 14.2 15.1 16.3 2.8.9 5.1.5 7.2-1.1 2.7-2.1 3.2-4.8 3.1-6.6-.1-3.2-2-6.4-4.8-8.3C1326.7 547.5 1317.7 545.6 1311 546.7z'/%3E%3C/g%3E%3C/svg%3E")`;
    const CONFETTI_DARK = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1500' height='745' viewBox='0 0 1600 800'%3E%3Cpath fill='%23${confetti.dark.primary}' d='M1102.5 734.8c2.5-1.2 24.8-8.6 25.6-7.5.5.7-3.9 23.8-4.6 24.5C1123.3 752.1 1107.5 739.5 1102.5 734.8zM1226.3 229.1c0-.1-4.9-9.4-7-14.2-.1-.3-.3-1.1-.4-1.6-.1-.4-.3-.7-.6-.9-.3-.2-.6-.1-.8.1l-13.1 12.3c0 0 0 0 0 0-.2.2-.3.5-.4.8 0 .3 0 .7.2 1 .1.1 1.4 2.5 2.1 3.6 2.4 3.7 6.5 12.1 6.5 12.2.2.3.4.5.7.6.3 0 .5-.1.7-.3 0 0 1.8-2.5 2.7-3.6 1.5-1.6 3-3.2 4.6-4.7 1.2-1.2 1.6-1.4 2.1-1.6.5-.3 1.1-.5 2.5-1.9C1226.5 230.4 1226.6 229.6 1226.3 229.1zM33 770.3C33 770.3 33 770.3 33 770.3c0-.7-.5-1.2-1.2-1.2-.1 0-.3 0-.4.1-1.6.2-14.3.1-22.2 0-.3 0-.6.1-.9.4-.2.2-.4.5-.4.9 0 .2 0 4.9.1 5.9l.4 13.6c0 .3.2.6.4.9.2.2.5.3.8.3 0 0 .1 0 .1 0 7.3-.7 14.7-.9 22-.6.3 0 .7-.1.9-.3.2-.2.4-.6.4-.9C32.9 783.3 32.9 776.2 33 770.3z'/%3E%3Cpath fill='%23${confetti.dark.secondary}' d='M171.1 383.4c1.3-2.5 14.3-22 15.6-21.6.8.3 11.5 21.2 11.5 22.1C198.1 384.2 177.9 384 171.1 383.4zM596.4 711.8c-.1-.1-6.7-8.2-9.7-12.5-.2-.3-.5-1-.7-1.5-.2-.4-.4-.7-.7-.8-.3-.1-.6 0-.8.3L574 712c0 0 0 0 0 0-.2.2-.2.5-.2.9 0 .3.2.7.4.9.1.1 1.8 2.2 2.8 3.1 3.1 3.1 8.8 10.5 8.9 10.6.2.3.5.4.8.4.3 0 .5-.2.6-.5 0 0 1.2-2.8 2-4.1 1.1-1.9 2.3-3.7 3.5-5.5.9-1.4 1.3-1.7 1.7-2 .5-.4 1-.7 2.1-2.4C596.9 713.1 596.8 712.3 596.4 711.8zM727.5 179.9C727.5 179.9 727.5 179.9 727.5 179.9c.6.2 1.3-.2 1.4-.8 0-.1 0-.2 0-.4.2-1.4 2.8-12.6 4.5-19.5.1-.3 0-.6-.2-.8-.2-.3-.5-.4-.8-.5-.2 0-4.7-1.1-5.7-1.3l-13.4-2.7c-.3-.1-.7 0-.9.2-.2.2-.4.4-.5.6 0 0 0 .1 0 .1-.8 6.5-2.2 13.1-3.9 19.4-.1.3 0 .6.2.9.2.3.5.4.8.5C714.8 176.9 721.7 178.5 727.5 179.9zM728.5 178.1c-.1-.1-.2-.2-.4-.2C728.3 177.9 728.4 178 728.5 178.1z'/%3E%3Cg fill-opacity='0.05' fill='%23FFF'%3E%3Cpath d='M699.6 472.7c-1.5 0-2.8-.8-3.5-2.3-.8-1.9 0-4.2 1.9-5 3.7-1.6 6.8-4.7 8.4-8.5 1.6-3.8 1.7-8.1.2-11.9-.3-.9-.8-1.8-1.2-2.8-.8-1.7-1.8-3.7-2.3-5.9-.9-4.1-.2-8.6 2-12.8 1.7-3.1 4.1-6.1 7.6-9.1 1.6-1.4 4-1.2 5.3.4 1.4 1.6 1.2 4-.4 5.3-2.8 2.5-4.7 4.7-5.9 7-1.4 2.6-1.9 5.3-1.3 7.6.3 1.4 1 2.8 1.7 4.3.5 1.1 1 2.2 1.5 3.3 2.1 5.6 2 12-.3 17.6-2.3 5.5-6.8 10.1-12.3 12.5C700.6 472.6 700.1 472.7 699.6 472.7zM740.4 421.4c1.5-.2 3 .5 3.8 1.9 1.1 1.8.4 4.2-1.4 5.3-3.7 2.1-6.4 5.6-7.6 9.5-1.2 4-.8 8.4 1.1 12.1.4.9 1 1.7 1.6 2.7 1 1.7 2.2 3.5 3 5.7 1.4 4 1.2 8.7-.6 13.2-1.4 3.4-3.5 6.6-6.8 10.1-1.5 1.6-3.9 1.7-5.5.2-1.6-1.4-1.7-3.9-.2-5.4 2.6-2.8 4.3-5.3 5.3-7.7 1.1-2.8 1.3-5.6.5-7.9-.5-1.3-1.3-2.7-2.2-4.1-.6-1-1.3-2.1-1.9-3.2-2.8-5.4-3.4-11.9-1.7-17.8 1.8-5.9 5.8-11 11.2-14C739.4 421.6 739.9 421.4 740.4 421.4zM261.3 590.9c5.7 6.8 9 15.7 9.4 22.4.5 7.3-2.4 16.4-10.2 20.4-3 1.5-6.7 2.2-11.2 2.2-7.9-.1-12.9-2.9-15.4-8.4-2.1-4.7-2.3-11.4 1.8-15.9 3.2-3.5 7.8-4.1 11.2-1.6 1.2.9 1.5 2.7.6 3.9-.9 1.2-2.7 1.5-3.9.6-1.8-1.3-3.6.6-3.8.8-2.4 2.6-2.1 7-.8 9.9 1.5 3.4 4.7 5 10.4 5.1 3.6 0 6.4-.5 8.6-1.6 4.7-2.4 7.7-8.6 7.2-15-.5-7.3-5.3-18.2-13-23.9-4.2-3.1-8.5-4.1-12.9-3.1-3.1.7-6.2 2.4-9.7 5-6.6 5.1-11.7 11.8-14.2 19-2.7 7.7-2.1 15.8 1.9 23.9.7 1.4.1 3.1-1.3 3.7-1.4.7-3.1.1-3.7-1.3-4.6-9.4-5.4-19.2-2.2-28.2 2.9-8.2 8.6-15.9 16.1-21.6 4.1-3.1 8-5.1 11.8-6 6-1.4 12 0 17.5 4C257.6 586.9 259.6 588.8 261.3 590.9z'/%3E%3Ccircle cx='1013.7' cy='153.9' r='7.1'/%3E%3Ccircle cx='1024.3' cy='132.1' r='7.1'/%3E%3Ccircle cx='1037.3' cy='148.9' r='7.1'/%3E%3Cpath d='M1508.7 297.2c-4.8-5.4-9.7-10.8-14.8-16.2 5.6-5.6 11.1-11.5 15.6-18.2 1.2-1.7.7-4.1-1-5.2-1.7-1.2-4.1-.7-5.2 1-4.2 6.2-9.1 11.6-14.5 16.9-4.8-5-9.7-10-14.7-14.9-1.5-1.5-3.9-1.5-5.3 0-1.5 1.5-1.5 3.9 0 5.3 4.9 4.8 9.7 9.8 14.5 14.8-1.1 1.1-2.3 2.2-3.5 3.2-4.1 3.8-8.4 7.8-12.4 12-1.4 1.5-1.4 3.8 0 5.3 0 0 0 0 0 0 1.5 1.4 3.9 1.4 5.3-.1 3.9-4 8.1-7.9 12.1-11.7 1.2-1.1 2.3-2.2 3.5-3.3 4.9 5.3 9.8 10.6 14.6 15.9.1.1.1.1.2.2 1.4 1.4 3.7 1.5 5.2.2C1510 301.2 1510.1 298.8 1508.7 297.2zM327.6 248.6l-.4-2.6c-1.5-11.1-2.2-23.2-2.3-37 0-5.5 0-11.5.2-18.5 0-.7 0-1.5 0-2.3 0-5 0-11.2 3.9-13.5 2.2-1.3 5.1-1 8.5.9 5.7 3.1 13.2 8.7 17.5 14.9 5.5 7.8 7.3 16.9 5 25.7-3.2 12.3-15 31-30 32.1L327.6 248.6zM332.1 179.2c-.2 0-.3 0-.4.1-.1.1-.7.5-1.1 2.7-.3 1.9-.3 4.2-.3 6.3 0 .8 0 1.7 0 2.4-.2 6.9-.2 12.8-.2 18.3.1 12.5.7 23.5 2 33.7 11-2.7 20.4-18.1 23-27.8 1.9-7.2.4-14.8-4.2-21.3l0 0C347 188.1 340 183 335 180.3 333.6 179.5 332.6 179.2 332.1 179.2zM516.3 60.8c-.1 0-.2 0-.4-.1-2.4-.7-4-.9-6.7-.7-.7 0-1.3-.5-1.4-1.2 0-.7.5-1.3 1.2-1.4 3.1-.2 4.9 0 7.6.8.7.2 1.1.9.9 1.6C517.3 60.4 516.8 60.8 516.3 60.8zM506.1 70.5c-.5 0-1-.3-1.2-.8-.8-2.1-1.2-4.3-1.3-6.6 0-.7.5-1.3 1.2-1.3.7 0 1.3.5 1.3 1.2.1 2 .5 3.9 1.1 5.8.2.7-.1 1.4-.8 1.6C506.4 70.5 506.2 70.5 506.1 70.5zM494.1 64.4c-.4 0-.8-.2-1-.5-.4-.6-.3-1.4.2-1.8 1.8-1.4 3.7-2.6 5.8-3.6.6-.3 1.4 0 1.7.6.3.6 0 1.4-.6 1.7-1.9.9-3.7 2-5.3 3.3C494.7 64.3 494.4 64.4 494.1 64.4zM500.5 55.3c-.5 0-.9-.3-1.2-.7-.5-1-1.2-1.9-2.4-3.4-.3-.4-.7-.9-1.1-1.4-.4-.6-.3-1.4.2-1.8.6-.4 1.4-.3 1.8.2.4.5.8 1 1.1 1.4 1.3 1.6 2.1 2.6 2.7 3.9.3.6 0 1.4-.6 1.7C500.9 55.3 500.7 55.3 500.5 55.3zM506.7 55c-.3 0-.5-.1-.8-.2-.6-.4-.7-1.2-.3-1.8 1.2-1.7 2.3-3.4 3.3-5.2.3-.6 1.1-.9 1.7-.5.6.3.9 1.1.5 1.7-1 1.9-2.2 3.8-3.5 5.6C507.4 54.8 507.1 55 506.7 55zM1029.3 382.8c-.1 0-.2 0-.4-.1-2.4-.7-4-.9-6.7-.7-.7 0-1.3-.5-1.4-1.2 0-.7.5-1.3 1.2-1.4 3.1-.2 4.9 0 7.6.8.7.2 1.1.9.9 1.6C1030.3 382.4 1029.8 382.8 1029.3 382.8zM1019.1 392.5c-.5 0-1-.3-1.2-.8-.8-2.1-1.2-4.3-1.3-6.6 0-.7.5-1.3 1.2-1.3.7 0 1.3.5 1.3 1.2.1 2 .5 3.9 1.1 5.8.2.7-.1 1.4-.8 1.6C1019.4 392.5 1019.2 392.5 1019.1 392.5zM1007.1 386.4c-.4 0-.8-.2-1-.5-.4-.6-.3-1.4.2-1.8 1.8-1.4 3.7-2.6 5.8-3.6.6-.3 1.4 0 1.7.6.3.6 0 1.4-.6 1.7-1.9.9-3.7 2-5.3 3.3C1007.7 386.3 1007.4 386.4 1007.1 386.4zM1013.5 377.3c-.5 0-.9-.3-1.2-.7-.5-1-1.2-1.9-2.4-3.4-.3-.4-.7-.9-1.1-1.4-.4-.6-.3-1.4.2-1.8.6-.4 1.4-.3 1.8.2.4.5.8 1 1.1 1.4 1.3 1.6 2.1 2.6 2.7 3.9.3.6 0 1.4-.6 1.7C1013.9 377.3 1013.7 377.3 1013.5 377.3zM1019.7 377c-.3 0-.5-.1-.8-.2-.6-.4-.7-1.2-.3-1.8 1.2-1.7 2.3-3.4 3.3-5.2.3-.6 1.1-.9 1.7-.5.6.3.9 1.1.5 1.7-1 1.9-2.2 3.8-3.5 5.6C1020.4 376.8 1020.1 377 1019.7 377zM1329.7 573.4c-1.4 0-2.9-.2-4.5-.7-8.4-2.7-16.6-12.7-18.7-20-.4-1.4-.7-2.9-.9-4.4-8.1 3.3-15.5 10.6-15.4 21 0 1.5-1.2 2.7-2.7 2.8 0 0 0 0 0 0-1.5 0-2.7-1.2-2.7-2.7-.1-6.7 2.4-12.9 7-18 3.6-4 8.4-7.1 13.7-8.8.5-6.5 3.1-12.9 7.4-17.4 7-7.4 18.2-8.9 27.3-10.1l.7-.1c1.5-.2 2.9.9 3.1 2.3.2 1.5-.9 2.9-2.3 3.1l-.7.1c-8.6 1.2-18.4 2.5-24 8.4-3 3.2-5 7.7-5.7 12.4 7.9-1 17.7 1.3 24.3 5.7 4.3 2.9 7.1 7.8 7.2 12.7.2 4.3-1.7 8.3-5.2 11.1C1335.2 572.4 1332.6 573.4 1329.7 573.4zM1311 546.7c.1 1.5.4 3 .8 4.4 1.7 5.8 8.7 14.2 15.1 16.3 2.8.9 5.1.5 7.2-1.1 2.7-2.1 3.2-4.8 3.1-6.6-.1-3.2-2-6.4-4.8-8.3C1326.7 547.5 1317.7 545.6 1311 546.7z'/%3E%3C/g%3E%3C/svg%3E")`;

    return (
        <Box >
            <Box w={"100%"} mt={3} mb={2}>
                <Text as="cite" fontSize={{ base: "18px", md: "20px", lg: "22px" }} color="gray"><span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t("Accueil")}</span>  / <span onClick={() => navigate('/apa-agency-services')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >Services</span> / <span> {t("Modifier le service")}</span></Text>
            </Box>
            <Flex
                direction={{ base: 'column', md: 'row' }}
                align={{ base: 'stretch', md: 'center' }}
                justify={"center"}
                p={5}
            >

                <Stack
                    bg={useColorModeValue('white', 'gray.700')}
                    rounded={'lg'}
                    p={6}
                    my={5}
                    w={{ base: '100%', md: '100%', lg: '80%', xl: '60%', sm: '100%' }}
                >
                    {message &&
                        <Alert fontSize={"sm"} padding={2} status='error' rounded="md">
                            <AlertIcon />
                            {message}
                        </Alert>
                    }
                    <Box p={5} rounded={'lg'} w="100%" maxW="full"
                        align={'center'}
                        justify={'center'}
                    >
                        <Stack spacing={2} w={{ base: '100%', md: '100%', lg: '100%', sm: '100%' }}
                        >

                            <Flex flexDirection={'column'} justify={'center'} align={'center'}>
                                <Box mb="5" color="#6b98c2" display="flex" alignItems="center">
                                    <Text>
                                        {t("Ajoutez jusqu'à 5 images")} {'(*.png, *.jpeg, *.jpg, *.webp)'}

                                    </Text>
                                </Box>
                                <Flex
                                    align={'center'}
                                    w={"100%"}
                                    // gap={2}
                                    px={5}
                                    py={5}
                                    justify={'center'}
                                    // py={{ base: 3, xl: 0 }}

                                    minHeight={"100px"}
                                // style={{
                                //     border: '1px dashed lightgray',
                                // }}
                                >
                                    {selectedImageList.length === 0 && (
                                        <Flex
                                        // align={'center'}
                                        // justify={'center'}
                                        // style={{ width: '100%' }}
                                        >
                                            <Button
                                                size={{ base: 'sm', md: 'md' }}
                                                ml={{ base: 0, lg: 5 }}
                                                colorScheme='green'
                                                variant='outline'
                                            >
                                                <AiOutlinePlus style={{ fontSize: '18px', marginRight: 2 }} />
                                                <Text ml="2" fontWeight="lighter">
                                                    {t("Télécharger des images")}
                                                </Text>
                                                <input
                                                    key={inputKey}
                                                    multiple
                                                    type="file"
                                                    id="inputGroupFile01"
                                                    style={{
                                                        position: 'absolute',
                                                        left: 0,
                                                        top: 0,
                                                        height: '100%',
                                                        opacity: 0,
                                                        cursor: 'pointer',
                                                    }}
                                                    onMouseEnter={(e) => (e.target.style.cursor = 'pointer')}
                                                    onMouseLeave={(e) => (e.target.style.cursor = 'context-menu')}
                                                    onChange={handleChangeImage}
                                                    accept="image/png,image/jpg,image/jpeg,image/webp"
                                                />
                                            </Button>
                                        </Flex>
                                    )}
                                    <Grid templateColumns={{ base: 'repeat(1,1fr)', sm: 'repeat(3,1fr)', md: 'repeat(3,1fr)', lg: 'repeat(4,1fr)', xl: 'repeat(5,1fr)' }} gap={3}>

                                        {selectedImageList &&
                                            selectedImageList.map((val, key) => (
                                                <GridItem>

                                                    <Flex
                                                        flexDirection={'row'}
                                                        w={"100%"}
                                                        key={key}
                                                        style={{
                                                            position: 'relative',
                                                        }}
                                                    >
                                                        <Avatar
                                                            size={"xl"}
                                                            src={val}
                                                            borderRadius={"10px"}
                                                            style={{

                                                                objectFit: 'contain',
                                                            }}
                                                        >
                                                            <AvatarBadge style={{
                                                                width: '20px',
                                                                height: '20px',
                                                                position: 'absolute',
                                                                fontSize: 10,

                                                                cursor: 'pointer',
                                                                // color: '#c7c4c4',
                                                                background: 'black',
                                                                right: '-5%',
                                                                top: '-5%',
                                                            }}  >
                                                                <CloseIcon
                                                                    onClick={() => {
                                                                        // deleteimg(key)
                                                                        const newImageList = imageListe;
                                                                        const deleteItemImageListe = newImageList.splice(key, 1);
                                                                        setSelectedImageList(
                                                                            selectedImageList.filter((e) => e !== val)
                                                                        );
                                                                     
                                                                        setimageListe(newImageList);
                                                                    }} />
                                                            </AvatarBadge>

                                                        </Avatar>

                                                        {/* <CloseButton
                                                        style={{
                                                            width: '20px',
                                                            height: '20px',
                                                            position: 'absolute',
                                                            fontSize: 10,
                                                            cursor: 'pointer',
                                                            color: '#c7c4c4',
                                                            background: 'black',
                                                            right: '2%',
                                                            top: '0%',
                                                            borderRadius: '50%',
                                                        }}
                                                        onClick={() => {
                                                            // deleteimg(key)
                                                            const newImageList = imageListe;
                                                            const deleteItemImageListe = newImageList.splice(key, 1);
                                                            setSelectedImageList(
                                                                selectedImageList.filter((e) => e !== val)
                                                            );
                                                           
                                                            setimageListe(newImageList);
                                                        }}
                                                    /> */}
                                                    </Flex>
                                                </GridItem>
                                            ))}

                                        {selectedImageList.length > 0 && selectedImageList.length < 5 && (
                                            <Flex
                                                align={'center'}
                                                justify={'center'}
                                                style={{
                                                    height: '100px',
                                                }}
                                            >
                                                <Button
                                                    colorScheme='blue'
                                                    variant='outline'
                                                >
                                                    <AiOutlinePlus style={{ fontSize: 22 }} />
                                                    <input
                                                        key={inputKey}
                                                        multiple
                                                        type="file"
                                                        onChange={handleChangeImage}
                                                        style={{
                                                            position: 'absolute',
                                                            width: '100%',
                                                            height: '100%',
                                                            top: 0,
                                                            left: 0,
                                                            opacity: 0,
                                                        }}
                                                        accept="image/png,image/jpg,image/jpeg,image/webp"
                                                    />
                                                </Button>
                                            </Flex>
                                        )}
                                    </Grid>
                                </Flex>
                            </Flex>


                            <HStack spacing={2}>
                                <Box w="100%">
                                    <FormControl id="titre" isRequired >
                                        <FormLabel ml={0.5}>{t("Titre")}  </FormLabel>
                                        <Input
                                            defaultValue={data.title} onChange={(e) => setTitle(e.target.value)}
                                            name="titre" type="text" placeholder={t('Tapez le titre')} maxLength={50} />
                                    </FormControl>
                                </Box>

                            </HStack>
                            <HStack spacing={2}>
                                <Box w="100%">
                                    <FormControl id="email" isRequired >
                                        <FormLabel ml={0.5}>Description</FormLabel>
                                        <Textarea
                                            resize={'none'}
                                            defaultValue={data.description} onChange={(e) => setDescription(e.target.value)}
                                            name="description" type="text" placeholder={t("Tapez la description")} maxLength={250} />
                                    </FormControl>
                                </Box>

                            </HStack>
                            <HStack spacing={2}>

                            <Box w="50%">
                                    <FormControl id="email" isRequired >
                                        <FormLabel ml={0.5}>{t("Prix")}</FormLabel>
                                        <Input
                                            defaultValue={data.price} onChange={(e) => setPrice(e.target.value)}
                                            name="titre" type="number" placeholder={t('Entrez le prix')} maxLength={50} />
                                    </FormControl>
                                </Box>
                                <Box w="50%">
                                    <FormControl id="devise" isRequired >
                                        <FormLabel ml={0.5}>{t("Devise")} </FormLabel>
                                        <Select value={selectedCurrency ? selectedCurrency : data.currency}
                                            onChange={(e) => setSelectedCurrency(e.target.value)}>
                                            <option value="">{t("toutes les devises")}</option>
                                            <option value="eur">EUR</option>
                                            <option value="mad">MAD</option>
                                            <option value="usd">USD</option>
                                        </Select>
                                    </FormControl>
                                </Box>
                            </HStack>
                            <HStack spacing={2}>
                                <Box w="50%">
                                    <FormControl id="type" isRequired >
                                        <FormLabel ml={0.5}>{t("Type")}</FormLabel>
                                        <Select value={selectedType ? selectedType : data.type}
                                            onChange={(e) => setSelectedType(e.target.value)}
                                        >
                                            <option value="">{t("tous les types")}</option>
                                            <option value="Vente">{t("Vente")}</option>
                                            <option value="Location">{t("Location")}</option>

                                        </Select>

                                    </FormControl>
                                </Box>
                                <Box w="50%">
                                    <FormControl id="category" isRequired >
                                        <FormLabel ml={0.5}>{t("Catégorie")}</FormLabel>
                                        <Select value={selectedCategory ? selectedCategory : data.category}
                                            onChange={(e) => setSelectedCategory(e.target.value)}
                                        >
                                            <option value="">{t("Toutes les catégories")}</option>
                                            <option value="Appartement">{t("Appartement")}</option>
                                            <option value="Villa">{t("Villa")}</option>
                                            <option value="Terrain">{t("Terrain")}</option>
                                            <option value="Commerce">{t("Commerce")}</option>
                                        </Select>

                                    </FormControl>
                                </Box>

                            </HStack>
                            <Checkbox
                            py={2}
                                sx={{
                                    '& .chakra-checkbox__control': {
                                        bg: isChecked ? 'blue.500' : 'rgb(189,190,191,0.1)', // Change the background color based on the checked state
                                        borderColor: isChecked ? 'blue.500' : 'gray.300',
                                    },
                                    '& .chakra-checkbox__control[data-checked]': {
                                        bg: 'blue.500', // Background color when checked
                                        borderColor: 'blue.500',
                                    }
                                }}
                                isChecked={isChecked}
                                onChange={e => {
                                    setIsChecked(e.target.checked);
                                }}
                            >
                                {t("Activé")}
                            </Checkbox>
                            <Stack direction={['column', 'row']} spacing={10} pt={2} justifyContent="end">
                                {/* {
                                    isEmpty() ? (
                                        <Button
                                            type="submit"
                                            onClick={onSubmit}
                                            isLoading={isLoading}
                                            colorScheme="gray"
                                            isDisabled
                                            leftIcon={<GrAdd />}
                                        >
                                            {isLoading ? <Spinner size="sm" /> : "Ajouter"}
                                        </Button>
                                    ) : ( */}
                                <Button
                                    type="submit"
                                    onClick={onSubmit}
                                    isLoading={isLoading}
                                    colorScheme="gray"
                                    leftIcon={<FiEdit3 />}
                                >
                                    {isLoading ? <Spinner size="sm" /> : t("Modifier")}
                                </Button>
                                {/* )
                                } */}
                            </Stack>
                        </Stack>
                    </Box>
                </Stack>
                {/* <Stack w="40%"
                   
                >
                    <Image px={10} height={"500px"}   objectFit={"cover"}

                       display={{ base: 'none', lg: 'flex' }} src={property} />
                </Stack> */}
            </Flex>
        </Box>

    )
}